














































import Vue from "vue";

// Routing
import * as routes from "@/router/routes";

// Vuex
import { mapGetters, mapMutations, mapState } from "vuex";
import { OPEN_DEVICE_TREE_TO_FOLDER_ID } from "@/store/modules/ApplicationModule/mutations";

// Model
import { findParentNodesFromInstallationName } from "@/utility/TreeviewUtility";
import { FetchInstallationsStatusCommand, GetDevicesStatusReqData } from "@/model/communication/status/FetchInstallationsStatusCommand";
import { FetchInstallationsStatusResponse } from "@/model/communication/status/FetchInstallationsStatusResponse";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";

// Components
import InstallationResumeDialog from "@/components/InstallationResumeDialog.vue";

export default Vue.extend({
    components: {
        InstallationResumeDialog,
    },
    props: {
        installationName: { type: String, required: true },
    },
    data() {
        return {
            routes,
            items: [],
            selectedInstallation: null,
            loading: false,
            showDialog: false,
        };
    },
    computed: {
        ...mapState({
            deviceTree: (state: any) => state.devices.deviceTree,
        }),
        ...mapGetters(["authUserHasPrivilege"]),

        linkEnabled() {
            return this.authUserHasPrivilege(ClientPrivileges.StatusManagement);
        },
    },
    watch: {
        installationName() {
            this.getInstallationTreePath();
        },
    },
    methods: {
        ...mapMutations([OPEN_DEVICE_TREE_TO_FOLDER_ID]),

        getInstallationTreePath() {
            this.items = [];
            let parentNodes = findParentNodesFromInstallationName(this.deviceTree, this.installationName);
            parentNodes.forEach((parentNode) => {
                this.items.push({
                    text: parentNode.name,
                    folderId: parentNode.id,
                });
            });
        },

        onFolderClick(folderId) {
            this[OPEN_DEVICE_TREE_TO_FOLDER_ID](folderId);
        },

        async handleClick() {
            this.loading = true;
            let req: GetDevicesStatusReqData = new GetDevicesStatusReqData();
            req.installationNames = [];
            req.installationNames.push(this.installationName);
            let response: FetchInstallationsStatusResponse = await new FetchInstallationsStatusCommand(req).execute();
            if (response.responseStatus == ApiResponseStatusEnum.Success) {
                this.showDialog = true;
                this.selectedInstallation = response.installationsList[0];
            }
            this.loading = false;
        },
    },
    mounted() {
        this.getInstallationTreePath();
    },
});
